import { useContext } from 'react';
import { store } from 'components/Store';
import { useAuth0 } from '@auth0/auth0-react';
import ClientsPicker from './ClientsPicker';
import NavPages from './NavPages';
import { useNavigate, useLocation } from 'react-router';
import createSectionViewStoreProperty from 'components/Dashboard/ParliamentLive/createSectionViewStoreProperty';
import useDetectRateMode from 'components/Dashboard/ListControl/useDetectRateMode';

const useCloseSectionsCondition = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { clickedOnContentUrl } = state;

  const location = useLocation();

  const savedItems = location.pathname.startsWith('/saved-items');
  const search = location.pathname.startsWith('/search-results');
  const calendar = location.pathname.startsWith('/calendar');
  const notes = location.pathname.startsWith('/notes');
  const specificPaths = savedItems || search || calendar || notes;
  const clickOnSearchItem = clickedOnContentUrl?.startsWith('/search-results');

  return { specificPaths, clickOnSearchItem, savedItems, search, calendar, notes };
};

const ClientNavigation = () => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { readyKeywordLists, prevUrl } = state;

  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const { resetClientNavigation, resetClientState } = useResetClientNavigation();

  const { specificPaths, clickOnSearchItem, savedItems, search, calendar, notes } = useCloseSectionsCondition();

  const createNameOfCloseButton = () => {
    if (savedItems) {
      return `saved items`;
    } else if (search || clickOnSearchItem) {
      return `search`;
    } else if (calendar) {
      return `calendar`;
    } else if (notes) {
      return `note log`;
    } else {
      return '';
    }
  };
  const { rateUpdatesMode } = useDetectRateMode();

  return (
    <>
      {readyKeywordLists && isAuthenticated && (
        <>
          {specificPaths || clickOnSearchItem ? (
            <div className='w-100 flex-centered justify-content-end rounded-pill'>
              <button
                className='rounded-pill py-1 general-button bg-yellow text-white client-navigation-close-button'
                onClick={() => {
                  resetClientNavigation();
                  resetClientState();
                  dispatch({
                    type: 'MODIFY_SECTION',
                    parameter: 'sectionsView',
                    value: createSectionViewStoreProperty(),
                  });
                  navigate(prevUrl ?? '/');
                }}
              >
                Close {createNameOfCloseButton()}
                <span className='d-inline-block icon-close-bold paragraph-p6' />
              </button>
            </div>
          ) : (
            <div
              className={`flex-centered rounded-pill agency-clients-navigation ${rateUpdatesMode ? 'clients-navigation-rate-updates' : 'bg-white text-main-blue'}`}
            >
              <>
                <ClientsPicker dropdownAdditionalClass={'main-client-picker-lists'} />
                {!rateUpdatesMode && <NavPages />}
              </>
            </div>
          )}
        </>
      )}
    </>
  );
};

const useResetClientNavigation = () => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const resetClientNavigation = () => {
    dispatch({
      type: 'MODIFY_SECTION',
      parameter: 'prevUrl',
      value: null,
    });
    dispatch({ type: 'MODIFY_SECTION', parameter: 'clickedOnContentUrl', value: null });
  };

  const resetClientState = () => {
    dispatch({ type: 'MODIFY_SECTION', parameter: 'readySetCurrentTeam', value: null });
    dispatch({ type: 'MODIFY_SECTION', parameter: 'dispatchSearchForClients', value: null });
  };

  return { resetClientNavigation, resetClientState };
};

export { useResetClientNavigation, useCloseSectionsCondition };
export default ClientNavigation;
